module.exports = __webpack_public_path__ + "img/bingo_ball-50.ed9b96f2.png";